export var Vendor;
(function (Vendor) {
    Vendor[Vendor["PURE"] = 1] = "PURE";
    Vendor[Vendor["DSI"] = 2] = "DSI";
})(Vendor || (Vendor = {}));
